import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import Coach from '../../../../../../../Model/Coach';
import AssignmentNotificationSetting from '../AssignmentNotificationSetting';
import texts from './texts.json';

const MealPlanAssignmentNotification = ({ coachDoc }) => {
  const onSave = useCallback((value) => (
    coachDoc.setMealPlanAssignmentClientNotificationEnabled(value)
  ), [coachDoc]);

  return (
    <AssignmentNotificationSetting
      isEnabled={coachDoc.isMealPlanAssignmentClientNotificationEnabled}
      onSave={onSave}
      texts={texts}
    />
  );
};

MealPlanAssignmentNotification.propTypes = {
  coachDoc: PropTypes.instanceOf(Coach).isRequired,
};

export default compose(
  observer,
)(MealPlanAssignmentNotification);
